import mitt from 'mitt'

export const EventBusKey = {
  changeGenerateType: 'changeGenerateType', //AppGenerator页面切换Tab事件
  changeGenerateTypeOk: 'changeGenerateTypeOk', //AppBrush页面切换Tab事件,确认事件
  brushGeneratorInfo: 'brushGeneratorInfo', //InpaintingBrush 获取信息后,返回给AppGenerator
  brushIsCanDesign: 'brushIsCanDesign', //AppBrush页面, Design按钮是否可以点击
  sendImgToInpainting: 'sendImgToInpainting', //发送图片到Inpainting
  sendImgToImageRefrence: 'sendImgToImageRefrence', //发送图片到ImageRefrence
  sendImgToVideo: 'sendImgToVideo', //发送图片到Video
  sendImgFileToImageRefrence: 'sendImgFileToImageRefrence', //发送File图片到ImageRefrence
  hasChecked: 'hasChecked', //AppBrush页面, 结果图片是否有选中
  brushPromptTop: 'brushPromptTop',
  d3GenerateResult: 'd3GenerateResult', //3D页面, 生成完成
  generateResult: 'generateResult', //文生图，图生图
  hdGenerateResult: 'hdGenerateResult', //高清页面, 生成完成
  sendImgTo3D: 'sendImgTo3D', //发送图片到3D
  sendImgToHD: 'sendImgToHD', //发送图片到高清
  startHDTask: 'startHDTask', //在当前页面开始高清任务
  sendImgAndChangeModal: 'sendImgAndChangeModal', //发送图片到ImageRefrence, 并切换Modal
  willSendImgToImageRefrence: 'willSendImgToImageRefrence',
  willSendImgToInpainting: 'willSendImgToInpainting',
  showHistorySlide: 'showHistorySlide', //显示HistorySlide
  cancelLoopCheckResult: 'cancelLoopCheckResult', //取消循环检查结果
  imageDetailDeleteImage: 'imageDetailDeleteImage', //图片详情页删除图片,需要做刷新列表操作
  imageDetailDeleteImageCallback: 'imageDetailDeleteImageCallback', //图片详情页删除图片,通知生成结果列表做数据物理剔除逻辑
  d3DetailDeleteModel: 'd3DetailDeleteModel', //3D详情页删除模型,需要做刷新列表操作
  eduImageTo3D: 'eduImageTo3D', //Edu页面, 图片转3D
  showEduWelcomModal: 'showEduWelcomModal', //主站承接校园版，显示欢迎弹窗
  showEduHistoryModal: 'showEduHistoryModal', //主站承接校园版，显示学生课堂历史记录弹窗
  changeHeaderBackgroundColor: 'changeHeaderBackgroundColor', //改变Header背景颜色
  eduImageTo3DParam: 'eduImageTo3DParam', //Edu页面, 图片转3D, 携带参数
  eduHeaderBackBtnVisible: 'eduHeaderBackBtnVisible', //校园版工具页，需要显示返回按钮
  onboardingContentDetailData: 'onboardingContentDetailData', //  onboarding  contentDetail 页面数据
  confirmWantIt: 'confirmWantIt', // 确认想要
  knowAboutWatable: 'knowAboutWatable', // 作品详情页面点击了知道了
  chooseImageListchange: 'chooseImageListchange', // 选择图片列表变化
  generateRefresh: 'generateRefresh', // 生成页面刷新
  closeTicketConsumptionList: 'closeTicketConsumptionList', // 关闭票数的消费列表
  joinChallengeBtnVisible: 'hiddenJoinChallenge', // 隐藏挑战页面加入挑战按钮
  homeGeneratorParams: 'homeGeneratorParams', // 首页生成传参
  generateWithPrompt: 'generateWithPrompt',
  homeTab: 'homeTab', //首页目前Tab
  downloadFinished: 'downloadFinished',
  closeDeepSeekKit: 'closeDeepSeekKit' // 关闭随机骰子组件中DeepSeekKit
}

const emitter = mitt()

export default emitter
